module.exports = __webpack_public_path__ + "static/img/anxunu09.11870da2.png";